// Onboarding query keys factory.
// Mutations invalidate via the factory only — never raw arrays.

export const onboardingKeys = {
  all: ['onboarding'] as const,
  riskProfile: () => [...onboardingKeys.all, 'riskProfile'] as const,
  countries: () => [...onboardingKeys.all, 'countries'] as const,
  flow: () => [...onboardingKeys.all, 'flow'] as const,
  steps: () => [...onboardingKeys.all, 'steps'] as const,
}
